import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useUserProfile } from 'contexts/UserProfileContext';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import { NoopT } from 'declarations/types/common';

type UseColumnPickerSettingsPopupT = {
  isPopupOpened: boolean;
  handleCloseColumnPickerPopup: (onClosePopupCb: NoopT | undefined) => NoopT;
};

const useColumnPickerSettingsPopup = (): UseColumnPickerSettingsPopupT => {
  /**
   * Hooks
   */
  const { isColumnPickerPopupOpened, setColumnPickerPopupVisibility } = useUserProfile();
  const queryClient = useQueryClient();

  /**
   * Handlers
   */
  const handleCloseColumnPickerPopup = useCallback(
    (onClosePopupCb: NoopT | undefined) => () => {
      onClosePopupCb ? onClosePopupCb() : setColumnPickerPopupVisibility(false);
      queryClient.invalidateQueries([RequestQueryKeysE.FetchTickets]);
    },
    [setColumnPickerPopupVisibility, queryClient]
  );

  return {
    handleCloseColumnPickerPopup,
    isPopupOpened: isColumnPickerPopupOpened,
  };
};

export default useColumnPickerSettingsPopup;
